/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react';
import BetForm from './betForm'
import * as stringParser from '../../util/string.util'
import { calculateExpouser } from '../../util/expouser.util'
import Currency from './currency'
import Volume from './volume'
import { staticContentsImagePath as BASE_IMAGE_PATH, OPERATOR_ID } from '../../configs/const';
import { DemoBetDelay, allowCashout } from '../../configs/casinoShowList';
let oid = OPERATOR_ID.toLowerCase()
export default class WebMarket extends Component {
    constructor(props) {
        super(props);
        this.state = {
            runner_name: "",
            bid_at: "",
            bid_amount: 0,
            book: {},
            market: {},
            selectionId: "",
            expo: {},
            mktMsg:''
        };
        this.onChange = this.onChange.bind(this);
        this.changeBid = this.changeBid.bind(this);
    }
    selectBid(runner_name, bid_at, market_id, bid_for, team) {
        localStorage.setItem("betForm", JSON.stringify({ runner_name: runner_name, bid_at: bid_at, bid_amount: 0, selectionId: team.id.toString() }))
        this.setState({ runner_name: runner_name, bid_at: bid_at, bid_amount: 0, selectionId: team.id.toString() }, () => {
            this.props.betForm(market_id, bid_for, "clicked")
        })
    }
    componentWillUnmount() {
        if(!!this.props.socket){
            this.props.socket.off("market_room")
          }
    }
    componentWillReceiveProps() {
        if (this.props.isEventUpdate) {
            const socket = this.props.socket;
        let self = this
        if (this.props.market.bettingType === "BOOKMAKER" && !!this.props.teamSequence && this.props.teamSequence.length > 0) {
            this.props.market.runners = this.props.market.runners.sort(function (a, b) {
                return self.props.teamSequence.indexOf(a.name) - self.props.teamSequence.indexOf(b.name);
            });
            if (!!this.props.market.metadata && !!this.props.market.metadata.book) {
                this.props.market.metadata.book.runners = this.props.market.metadata.book.runners.sort(function (a, b) {
                    return parseFloat(a.selectionId) - parseFloat(b.selectionId);
                });
            }
        }
        this.setState({ market: this.props.market, book: !!this.props.feedBooks[this.props.market.marketId] ? this.props.feedBooks[this.props.market.marketId] : !!this.props.market.metadata && !!this.props.market.metadata.book ? this.props.market.metadata.book : {} }, () => {
            if (this.props.selected_market === this.props.market.marketId && this.props.market.bettingType === "BOOKMAKER" && (this.state.book.sportingEvent || this.state.book.status !== "OPEN")) {
                this.props.betForm("", "")
            }
        })
        if (!this.props.market.metadata || !this.props.market.metadata.book || this.props.market.metadata.book.status === "CLOSED" || this.props.market.metadata.book.status === "INACTIVE") {
            return false
        }
        if (localStorage.getItem("betExpo")) {
            this.setState({ expo: JSON.parse(localStorage.getItem("betExpo")) })
        }
        let stream = ""
        const accData = JSON.parse(localStorage.getItem("accountData"));
        if(!!accData && Object.keys(accData).length > 0) {
            socket.on("market_room", data => {
                if (stream !== data) {
                    stream = data
                    let newBook = null
                    try {
                        newBook = stringParser.deSrlz(data)
                    } catch {
                        let baseData = {
                            marketId: this.props.market.marketId,
                            status: "OPEN",
                            runners: []
                        }
                        this.state.market.runners.forEach((rnr) => {
                            let data = { "selectionId": rnr.id.toString(), "status": "ACTIVE", "back": [{ "price": "0", "size": "0", "line": "0" }, { "price": "0", "size": "0", "line": "0" }, { "price": "0", "size": "0", "line": "0" }], "lay": [{ "price": "0", "size": "0", "line": "0" }, { "price": "0", "size": "0", "line": "0" }, { "price": "0", "size": "0", "line": "0" }] }
                            baseData.runners.push(data)
                        })
                        newBook = baseData
                    }
                    if (this.props.market.bettingType === "BOOKMAKER") {
                        if (!!newBook.runners) {
                            newBook.runners = newBook.runners.sort(function (a, b) {
                                return parseFloat(a.selectionId) - parseFloat(b.selectionId);
                            });
                        }
                    }
                    if (this.props.market.marketId === newBook.marketId) {
                        this.props.updateBook(this.props.market.marketId, newBook)
                        let curBook = this.state.book
                        if (!curBook || !curBook.runners) {
                            this.setState({ book: newBook })
                            return false
                        }
                        curBook.runners.forEach((rn, i) => {
                            let nrn = newBook.runners[i]
                            if (!nrn) {
                                nrn = {}
                                nrn.back = [{ price: "NA", size: "NA" }, { price: "NA", size: "NA" }, { price: "NA", size: "NA" }]
                                nrn.lay = [{ price: "NA", size: "NA" }, { price: "NA", size: "NA" }, { price: "NA", size: "NA" }]
                            }
                            if (!nrn.back || nrn.back.length === 0) {
                                newBook.back = [{ price: "NA", size: "NA" }, { price: "NA", size: "NA" }, { price: "NA", size: "NA" }]
                            }
                            rn.back.forEach((bk, j) => {
                                if (!!nrn.back[j]) {
                                    if (bk.price !== nrn.back[j].price) {
                                        nrn.back[j].has_blink = true
                                    }
                                    else {
                                        nrn.back[j].has_blink = false
                                    }
                                }
                            })
                            if (!nrn.lay || nrn.lay.length === 0) {
                                newBook.back = [{ price: "NA", size: "NA" }, { price: "NA", size: "NA" }, { price: "NA", size: "NA" }]
                            }
                            if (!!rn.lay && rn.lay.length > 0) {
                                rn.lay.forEach((ly, k) => {
                                    if (!!nrn.lay[k]) {
                                        if (ly.price !== nrn.lay[k].price) {
                                            nrn.lay[k].has_blink = true
                                        }
                                        else {
                                            nrn.lay[k].has_blink = false
                                        }
                                    }
                                })
                            }
                            newBook.runners[i] = nrn
                        });
                        this.setState({ book: newBook }, () => {
                            if (this.props.selected_market === this.props.market.marketId && this.props.market.bettingType === "BOOKMAKER" && (this.state.book.sportingEvent || this.state.book.status !== "OPEN")) {
                                this.props.betForm("", "")
                            }
                            setTimeout(() => {
                                curBook.runners.forEach((rn, i) => {
                                    let nrn = newBook.runners[i]
                                    rn.back.forEach((bk, j) => {
                                        if (!!nrn.back[j]) {
                                            nrn.back[j].has_blink = false
                                        }
                                    })
                                    rn.lay.forEach((ly, k) => {
                                        if (!!nrn.lay[k]) { nrn.lay[k].has_blink = false }
                                    })
                                    newBook.runners[i] = nrn
                                });
                                this.setState({ book: newBook })
                            }, 500)
                        })
                    }
                }
            });
            socket.on('disconnect', () => {
                socket.emit('market_room', this.props.market.marketId)
            })
        }
        }}
    componentDidMount() {
        const socket = this.props.socket;
        let self = this
        if (this.props.market.bettingType === "BOOKMAKER" && !!this.props.teamSequence && this.props.teamSequence.length > 0) {
            this.props.market.runners = this.props.market.runners.sort(function (a, b) {
                return self.props.teamSequence.indexOf(a.name) - self.props.teamSequence.indexOf(b.name);
            });
            if (!!this.props.market.metadata && !!this.props.market.metadata.book) {
                this.props.market.metadata.book.runners = this.props.market.metadata.book.runners.sort(function (a, b) {
                    return parseFloat(a.selectionId) - parseFloat(b.selectionId);
                });
            }
        }
        this.setState({ market: this.props.market, book: !!this.props.feedBooks[this.props.market.marketId] ? this.props.feedBooks[this.props.market.marketId] : !!this.props.market.metadata && !!this.props.market.metadata.book ? this.props.market.metadata.book : {} }, () => {
            if (this.props.selected_market === this.props.market.marketId && this.props.market.bettingType === "BOOKMAKER" && (this.state.book.sportingEvent || this.state.book.status !== "OPEN")) {
                this.props.betForm("", "")
            }
        })
        if (!this.props.market.metadata || !this.props.market.metadata.book || this.props.market.metadata.book.status === "CLOSED" || this.props.market.metadata.book.status === "INACTIVE") {
            return false
        }
        if (localStorage.getItem("betExpo")) {
            this.setState({ expo: JSON.parse(localStorage.getItem("betExpo")) })
        }
        let stream = ""
        const accData = JSON.parse(localStorage.getItem("accountData"));
        if(!!accData && Object.keys(accData).length > 0) {
            if (this.props.subscribedMarkets.indexOf(this.props.market.marketId) === -1) {
                if (this.props.subscriptions.market_room.indexOf(this.props.market.marketId) === -1) {
                    socket.emit('market_room', this.props.market.marketId)
                    this.props.subscribe('market_room', this.props.market.marketId)
                    this.props.updateSubscribedMarkets(this.props.market.marketId)
                }
            }
            socket.on("message_room", data => {
                let objData = JSON.parse(data)
                if(!!objData.command && objData.command === 'MARKET_MESSAGE' && !!objData.payload && objData.payload.marketId ===  this.props.market.marketId){
                   this.setState({mktMsg:objData.payload.message})
                   if(this.props.updateMktMsg){
                    this.props.updateMktMsg(objData.payload)
                   }
                } 
            });
            
            socket.on("market_room", data => {
                if (stream !== data) {
                    stream = data
                    let newBook = null
                    try {
                        newBook = stringParser.deSrlz(data)
                    } catch {
                        let baseData = {
                            marketId: this.props.market.marketId,
                            status: "OPEN",
                            runners: []
                        }
                        this.state.market.runners.forEach((rnr) => {
                            let data = { "selectionId": rnr.id.toString(), "status": "ACTIVE", "back": [{ "price": "0", "size": "0", "line": "0" }, { "price": "0", "size": "0", "line": "0" }, { "price": "0", "size": "0", "line": "0" }], "lay": [{ "price": "0", "size": "0", "line": "0" }, { "price": "0", "size": "0", "line": "0" }, { "price": "0", "size": "0", "line": "0" }] }
                            baseData.runners.push(data)
                        })
                        newBook = baseData
                    }
                    if (this.props.market.bettingType === "BOOKMAKER") {
                        if (!!newBook.runners) {
                            newBook.runners = newBook.runners.sort(function (a, b) {
                                return parseFloat(a.selectionId) - parseFloat(b.selectionId);
                            });
                        }
                    }
                    if (this.props.market.marketId === newBook.marketId) {
                        this.props.updateBook(this.props.market.marketId, newBook)
                        let curBook = this.state.book
                        if (!curBook || !curBook.runners) {
                            this.setState({ book: newBook })
                            return false
                        }
                        curBook.runners.forEach((rn, i) => {
                            let nrn = newBook.runners[i]
                            if (!nrn) {
                                nrn = {}
                                nrn.back = [{ price: "NA", size: "NA" }, { price: "NA", size: "NA" }, { price: "NA", size: "NA" }]
                                nrn.lay = [{ price: "NA", size: "NA" }, { price: "NA", size: "NA" }, { price: "NA", size: "NA" }]
                            }
                            if (!nrn.back || nrn.back.length === 0) {
                                newBook.back = [{ price: "NA", size: "NA" }, { price: "NA", size: "NA" }, { price: "NA", size: "NA" }]
                            }
                            rn.back.forEach((bk, j) => {
                                if (!!nrn.back[j]) {
                                    if (bk.price !== nrn.back[j].price) {
                                        nrn.back[j].has_blink = true
                                    }
                                    else {
                                        nrn.back[j].has_blink = false
                                    }
                                }
                            })
                            if (!nrn.lay || nrn.lay.length === 0) {
                                newBook.back = [{ price: "NA", size: "NA" }, { price: "NA", size: "NA" }, { price: "NA", size: "NA" }]
                            }
                            if (!!rn.lay && rn.lay.length > 0) {
                                rn.lay.forEach((ly, k) => {
                                    if (!!nrn.lay[k]) {
                                        if (ly.price !== nrn.lay[k].price) {
                                            nrn.lay[k].has_blink = true
                                        }
                                        else {
                                            nrn.lay[k].has_blink = false
                                        }
                                    }
                                })
                            }
                            newBook.runners[i] = nrn
                        });
                        this.setState({ book: newBook }, () => {
                            if (this.props.selected_market === this.props.market.marketId && this.props.market.bettingType === "BOOKMAKER" && (this.state.book.sportingEvent || this.state.book.status !== "OPEN")) {
                                this.props.betForm("", "")
                            }
                            setTimeout(() => {
                                curBook.runners.forEach((rn, i) => {
                                    let nrn = newBook.runners[i]
                                    rn.back.forEach((bk, j) => {
                                        if (!!nrn.back[j]) {
                                            nrn.back[j].has_blink = false
                                        }
                                    })
                                    rn.lay.forEach((ly, k) => {
                                        if (!!nrn.lay[k]) { nrn.lay[k].has_blink = false }
                                    })
                                    newBook.runners[i] = nrn
                                });
                                this.setState({ book: newBook })
                            }, 500)
                        })
                    }
                }
            });
            socket.on('disconnect', () => {
                socket.emit('market_room', this.props.market.marketId)
            })
        }
    }
    changeBid(val) {
        this.setState({ bid_amount: val })
    }
    updateExpo(exp) {
        this.setState({ expo: {} }, () => {
            this.setState({ expo: exp })
        })
        localStorage.setItem("betExpo", JSON.stringify(exp))
    }
    onChange(e) {
        this.changeBid(e.target.value)
    }
    thexInputClick(val) {
        let cur_amount = this.state.bid_amount.toString()
        let new_amount = ""
        if (val !== "back") {
            new_amount = cur_amount + val.toString()
        } else {
            new_amount = cur_amount.substring(0, cur_amount.length - 1);
        }
        this.changeBid(new_amount)
    }
    userPropertyUpdate() {
        let market = this.props.market
        let userMktCondition = localStorage.getItem("accountData")
        userMktCondition = JSON.parse(userMktCondition)
        market.minBet = !!userMktCondition && userMktCondition.minBet ? Math.max(market.marketCondition.minBet, userMktCondition.minBet) : market.marketCondition.minBet
        if (market.marketCondition.maxBet === 0) {
            market.maxBet = !!userMktCondition ? userMktCondition.maxBet : 0; //userMktCondition.maxBet
        } else if (!userMktCondition || userMktCondition.maxBet === 0) {
            market.maxBet = market.marketCondition.maxBet
        } else {
            market.maxBet = market.marketCondition.maxBet
        }
        market.betDelay = !!userMktCondition ? Math.max(market.marketCondition.betDelay, userMktCondition.betDelay) : market.marketCondition.betDelay
        return market
    }
    findKeyWithMaxValue(obj) {
        let maxKey = null;
        let maxValue = Number.NEGATIVE_INFINITY;
      
        for (const key in obj) {
          if (obj.hasOwnProperty(key)) {
            if (obj[key] > maxValue) {
              maxKey = key;
              maxValue = obj[key];
            }
          }
        }
      
        return maxKey;
      }
    cashout(expo) {
      let market = this.userPropertyUpdate();
      let winIfRunner = this.findKeyWithMaxValue(expo);
      let sum = 0;
      for (let key in expo) {
        if (expo.hasOwnProperty(key)) {
          sum += Math.abs(expo[key]);
        }
      }

      let book = this.state.book;
      let fvtRunner = null;
      let minPrice = Number.POSITIVE_INFINITY;
      let runnerIndex = -1;
      let runner_name = "";
      book.runners.forEach((runner, i) => {
        // Check if back array has elements and back[0].price is higher than current maxPrice
        if (
          runner.back.length > 0 &&
          parseFloat(runner.back[0].price) < minPrice
        ) {
          minPrice = parseFloat(runner.back[0].price);
          fvtRunner = runner.selectionId;
          runnerIndex = i;
          runner_name = market.runners[i].name;
        }
      });
      console.log("winIfRunner", winIfRunner);
      console.log("fvtRunner", fvtRunner);
      let bhaav = 0;
      let side = "back";
      if (winIfRunner == fvtRunner) {
        bhaav = parseFloat(book.runners[runnerIndex].lay[0].price);
        side = "lay";
    } else {
        bhaav = parseFloat(book.runners[runnerIndex].back[0].price);
        side = "back";
      }
      let bmBhaav = bhaav;
      if(this.props.market.bettingType === "BOOKMAKER") {
        bhaav = (bhaav / 100) + 1;
      }
      let amount = parseFloat(sum / bhaav).toFixed(2);
      localStorage.setItem("betForm", JSON.stringify({ runner_name: runner_name, bid_at: bmBhaav, bid_amount: amount, selectionId: fvtRunner.toString() }))
        this.setState({ runner_name: runner_name, bid_at: bmBhaav, bid_amount: amount, selectionId: fvtRunner.toString() }, () => {
            this.props.betForm(market.marketId, side, "clicked")
        })
        let mktBets = this.props.curBets.filter((bet, i) => {
            return bet.marketId === this.props.market.marketId
        })
        let exp = calculateExpouser(market, market.runners[0].marketId, side, amount, bmBhaav, mktBets)
        this.updateExpo(exp);
    }

    addBetFn(dt, mkt){
        dt.marketId = mkt.marketId; 
        dt.selectionId = this.state.selectionId; 

        const prfdt = JSON.parse(localStorage.getItem('profData'));
        if(prfdt?.role === 'DemoClient'){
            this.props.togglebetLoader()    
                setTimeout(() => {    
                    let price = dt.price
                    this.state.book.runners.forEach((itm)=>{
                        if(itm.selectionId === dt.selectionId){
                            price = itm[dt.bet_for][0].price;
                        }
                    })
                    dt.price = price;
                    this.props.addBet(dt)
                }, DemoBetDelay);
        } else {
            this.props.addBet(dt)
        }
    }
    render() {
        const accData = JSON.parse(localStorage.getItem("accountData"));
        let market = this.userPropertyUpdate();
        let book = this.state.book
        let mktBets = []
        if (this.props.curBets) {
            mktBets = this.props.curBets.filter((bet, i) => {
                return bet.marketId === this.props.market.marketId
            })
        }
        let marketExpo = calculateExpouser(market, market.runners[0].marketId, "back", 0, 0, mktBets)
        let multiplayFector = market.marketCondition.volume
        let currencyConversion = (!!accData && Object.keys(accData).length > 0) ? JSON.parse(localStorage.getItem('profData')).currencyConversion : 1;
        return (
            <>
                {!!book && book !== {} && !!book.runners && book.runners.length > 0 && book.status !== "CLOSED" && book.status !== "INACTIVE" && <div className="live-match">
                    {!this.props.hideHeader && <div className="sub_path center-box crname">
                        <p>
                            {(!!accData && Object.keys(accData).length > 0) && <a id="multiMarketPin" onClick={(e) => { e.stopPropagation(); this.props.toggleMultiMarket(market.marketId); }} className={this.props.pinnedEvents.indexOf(market.marketId) > -1 ? "multimarket-pin select" : "multimarket-pin"} style={{ "cursor": "pointer" }} title="Remove from Multi Markets"><i className="fa fa-thumb-tack" aria-hidden="true"></i></a>}
                            <span className='mr-1'>{!!market.marketName ? market.marketName : market.marketType.replace("_", " ")}</span>
                            {this.props.isRebateBonus && <img alt="" src={BASE_IMAGE_PATH + "/casino/banner/images/rebatebonusicon.gif"} className="rebatebonusicon rebatebonusicon-mobile"></img>}
                            
                            <span className="f-right min-max ">
                                {this.props.isRebateBonus && <img alt="" src={BASE_IMAGE_PATH + "/casino/banner/images/rebatebonusicon.gif"} className="rebatebonusicon"></img>} <span className='desktop-minmax'>Min: {(market.minBet / currencyConversion).toFixed(2)} | Max: {(market.maxBet / currencyConversion).toFixed(2)}</span>
                                <span className={"f-right pl-3"}>{this.props.hideMkt.indexOf(market.marketId) > -1 ? <i className="fa fa-plus" aria-hidden="true" onClick={(e) => { e.stopPropagation(); this.props.toggleOpenMkt(market.marketId) }}></i> : <i className="fa fa-minus" aria-hidden="true" onClick={(e) => { e.stopPropagation(); this.props.toggleOpenMkt(market.marketId) }}></i>}</span>
                            </span>
                            {allowCashout && <span className="f-right min-max">
                                {market.runners.length === 2 && <button disabled={ mktBets.length === 0 } className='btn-cashout mr-2' onClick={()=>{this.cashout(marketExpo)}}>Cashout</button>}
                            </span>}
                            {/* <span>{!!market.marketName ? market.marketName : market.marketType.replace("_", " ")}</span><span className="f-right min-max"> Max: {market.maxBet} <span className={"f-right pl-3"}>{this.props.hideMkt.indexOf(market.marketId) > -1 ?<i className="fa fa-plus" aria-hidden="true" onClick={(e)=>{e.stopPropagation();this.props.toggleOpenMkt(market.marketId)}}></i>:<i className="fa fa-minus" aria-hidden="true" onClick={(e)=>{e.stopPropagation();this.props.toggleOpenMkt(market.marketId)}}></i>}</span></span> */}
                        </p>
                    </div>}
                    <div className="game-wrap col3">
                        {this.props.hideMkt.indexOf(market.marketId) === -1 &&
                            <table className="table w-100 game-list-col eventdetails bets mb-0">
                                <tbody>
                                    {market.bettingType !== "BOOKMAKER" ?
                                        <tr className="bet-all-new">
                                            <td className="w-55 pb-0 mob-minmax"><span className="f-right min-max text-black mob-minmax-span">Min: {(market.minBet / currencyConversion).toFixed(2)} | Max: {(market.maxBet / currencyConversion).toFixed(2)} </span></td>
                                            <td className="w-45 pb-0">
                                                <div>
                                                    <div className="w-50 float-left ">
                                                        <a id="btnBack" className="btn-back back-light-bg1 mobile-hide bg-trans" side="Back"> &nbsp;</a>
                                                        <a id="btnBack" className="btn-back back-light-bg mobile-hide bg-trans" side="Back">&nbsp;</a>
                                                        <a id="backAll" className="back-all"><img alt="" src={BASE_IMAGE_PATH + "/" + oid + "/uimg/transparent.gif"} /><span className="f11">Back</span></a>
                                                    </div>
                                                    <div className="w-50 float-left">
                                                        <a id="layAll" className="lay-all"><img alt="" src={BASE_IMAGE_PATH + "/" + oid + "/uimg/transparent.gif"} /><span className="f11">Lay</span></a>
                                                        <a id="btnBack" className="btn-lay lay-light-bg mobile-hide bg-trans" side="lay"> &nbsp;</a>
                                                        <a id="btnLay" className="btn-lay lay-light-bg1 mobile-hide bg-trans" side="lay"> &nbsp;</a>
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                        : <tr className="bet-all-new">
                                            <td className="w-55 pb-0 mob-minmax"><span className="f-right min-max text-black mob-minmax-span">Min: {(market.minBet / currencyConversion).toFixed(2)} | Max: {(market.maxBet / currencyConversion).toFixed(2)} </span></td>
                                            <td className="w-45 pb-0">
                                                <div className="">
                                                    <div className="w-50 float-left ">
                                                        <a id="btnBack" className="btn-back back-light-bg1 mobile-hide bg-trans" side="Back">&nbsp;</a>
                                                        <a id="btnBack" className="btn-back back-light-bg mobile-hide bg-trans" side="Back">&nbsp;</a>
                                                        {/* <a id="btnBack" className="btn-back bg-trans" side="Back">
                                                            <span>Back</span>
                                                        </a> */}
                                                        <a id="backAll" className="back-all"><img alt="" src={BASE_IMAGE_PATH + "/" + oid + "/uimg/transparent.gif"} /><span className="f11">Back</span></a>
                                                    </div>
                                                    <div className="w-50 float-left">
                                                        {/* <a id="btnBack" className="btn-lay bg-trans" side="lay">
                                                            <span>Lay</span>
                                                        </a> */}
                                                        <a id="layAll" className="lay-all"><img alt="" src={BASE_IMAGE_PATH + "/" + oid + "/uimg/transparent.gif"} /><span className="f11">Lay</span></a>
                                                        <a id="btnBack" className="btn-lay lay-light-bg mobile-hide bg-trans" side="lay"> &nbsp;</a>
                                                        <a id="btnLay" className="btn-lay lay-light-bg1 mobile-hide bg-trans" side="lay"> &nbsp;</a>
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                    }
                                    {!!market.runners && market.runners.map((runner, i) => {
                                        let runner_bk = !!this.state.book && this.state.book !== {} && !!this.state.book.runners && this.state.book.runners.length > 0 ? this.state.book.runners.filter((r) => { return r.selectionId.toString() === runner.id.toString() })[0] : null
                                        runner.name = market.runners[i].name
                                        let is_active = book.status === "OPEN" && runner_bk.status === "ACTIVE" ? true : false

                                        return (
                                            <>
                                                {runner_bk.status !== "REMOVED" && <tr>
                                                    <td className="w-55">
                                                        <span className="in-play-title">{runner.name}
                                                            {mktBets.length > 0 && <Currency key={"mktexpo"+runner.id} classPropName={"match-odds font-weight-bold"} amount={marketExpo[runner.id]} showColor={true} />}
                                                        </span>
                                                        <span className={"float-right"} style={{ paddingTop: "1rem" }}>
                                                            {!!this.state.expo && this.state.expo[runner.id] && this.props.selected_market === this.props.market.marketId ? <Currency key={"expo"} classPropName={"match-odds font-weight-bold"} amount={this.state.expo[runner.id]} showColor={true} /> : ""}
                                                        </span>
                                                    </td>
                                                    {!!runner_bk && runner_bk !== {} &&
                                                        <td className="w-45">
                                                            <div className={book.status === "OPEN" && runner_bk.status === "ACTIVE" ? book.sportingEvent === true ? "br-full" : "" : "suspended-event"}>
                                                                <div className="w-50 float-left ">
                                                                    {!!runner_bk.back && <a id="btnBack" className="btn-back back-light-bg1 mobile-hide" side="Back" onClick={() => { !!runner_bk.back[2] && !!runner_bk.back[2].price && runner_bk.back[2].price > 0 && !market.betLock && this.selectBid(runner.name, runner_bk.back[2].price, market.marketId, "back", runner) }} style={!!runner_bk.back[2] && runner_bk.back[2].has_blink ? { background: "gold", minHeight: 36 } : { minHeight: 36 }}>
                                                                        <div style={{ minHeight: "12px" }} className={market.bettingType === "BOOKMAKER" ? ((!!runner_bk.back[2] && parseFloat(runner_bk.back[2].price) !== 0 && !!runner_bk.back[2].size && runner_bk.back[2].size !== '0' && is_active) ? "" : "flhightbook") : ""}>{!!runner_bk.back[2] && parseFloat(runner_bk.back[2].price) !== 0 && is_active ? (runner_bk.back[2].price.indexOf('.') > -1 ? runner_bk.back[2].price.substring(0, (runner_bk.back[2].price.indexOf('.') + 3)) : runner_bk.back[2].price) : ""}</div>
                                                                        {(market.bettingType !== "BOOKMAKER" || (!!runner_bk.back[2] && parseFloat(runner_bk.back[2].price) !== 0 && !!runner_bk.back[2].size && runner_bk.back[2].size !== '0' && is_active)) && <span className="bid-price-small"><Volume bettingType={market?.bettingType} key="b2" volume={!!runner_bk.back[2] && parseFloat(runner_bk.back[2].price) !== 0 && is_active ? runner_bk.back[2].size / currencyConversion : "0"} multiplayFector={multiplayFector} /></span>}
                                                                    </a>}
                                                                    {!!runner_bk.back && <a id="btnBack" className="btn-back back-light-bg mobile-hide" side="Back" onClick={() => { !!runner_bk.back[1] && !!runner_bk.back[1].price && runner_bk.back[1].price > 0 && !market.betLock && this.selectBid(runner.name, runner_bk.back[1].price, market.marketId, "back", runner) }} style={!!runner_bk.back[1] && runner_bk.back[1].has_blink ? { background: "gold", minHeight: 36 } : { minHeight: 36 }}>
                                                                        <div style={{ minHeight: "12px" }} className={market.bettingType === "BOOKMAKER" ? ((!!runner_bk.back[1] && parseFloat(runner_bk.back[1].price) !== 0 && !!runner_bk.back[1].size && runner_bk.back[1].size !== '0' && is_active) ? "" : "flhightbook") : ""}>{!!runner_bk.back[1] && parseFloat(runner_bk.back[1].price) !== 0 && is_active ? (runner_bk.back[1].price.indexOf('.') > -1 ? runner_bk.back[1].price.substring(0, (runner_bk.back[1].price.indexOf('.') + 3)) : runner_bk.back[1].price) : ""}</div>
                                                                        {(market.bettingType !== "BOOKMAKER" || (!!runner_bk.back[1] && parseFloat(runner_bk.back[1].price) !== 0 && !!runner_bk.back[1].size && runner_bk.back[1].size !== '0' && is_active)) && <span className="bid-price-small"><Volume bettingType={market?.bettingType} key="b1" volume={!!runner_bk.back[1] && parseFloat(runner_bk.back[1].price) !== 0 && is_active ? runner_bk.back[1].size / currencyConversion : "0"} multiplayFector={multiplayFector} /></span>}
                                                                    </a>}
                                                                    {!!runner_bk.back && <a id="btnBack" className="btn-back" side="Back" onClick={() => { !!runner_bk.back[0] && !!runner_bk.back[0].price && runner_bk.back[0].price > 0 && !market.betLock && this.selectBid(runner.name, runner_bk.back[0].price, market.marketId, "back", runner) }} style={!!runner_bk.back[0] && runner_bk.back[0].has_blink ? { background: "gold", minHeight: 36 } : { minHeight: 36 }}>
                                                                        <div style={{ minHeight: "12px" }} className={market.bettingType === "BOOKMAKER" ? ((!!runner_bk.back[0] && parseFloat(runner_bk.back[0].price) !== 0 && !!runner_bk.back[0].size && runner_bk.back[0].size !== '0' && is_active) ? "" : "flhightbook") : ""}>{!!runner_bk.back[0] && parseFloat(runner_bk.back[0].price) !== 0 && is_active ? (runner_bk.back[0].price.indexOf('.') > -1 ? runner_bk.back[0].price.substring(0, (runner_bk.back[0].price.indexOf('.') + 3)) : runner_bk.back[0].price) : ""}</div>
                                                                        {(market.bettingType !== "BOOKMAKER" || (!!runner_bk.back[0] && parseFloat(runner_bk.back[0].price) !== 0 && !!runner_bk.back[0].size && runner_bk.back[0].size !== '0' && is_active)) && <span className="bid-price-small"><Volume bettingType={market?.bettingType} key="b0" volume={!!runner_bk.back[0] && parseFloat(runner_bk.back[0].price) !== 0 && is_active ? runner_bk.back[0].size / currencyConversion : "0"} multiplayFector={multiplayFector} /></span>}
                                                                    </a>}
                                                                </div>
                                                                <div className="w-50 float-left">
                                                                    {!!runner_bk.lay && <a id="btnBack" className="btn-lay" side="lay" onClick={() => { !!runner_bk.lay[0] && !!runner_bk.lay[0].price && runner_bk.lay[0].price > 0 && !market.betLock && this.selectBid(runner.name, runner_bk.lay[0].price, market.marketId, "lay", runner) }} style={!!runner_bk.lay[2] && runner_bk.lay[0].has_blink ? { background: "gold", minHeight: 36 } : { minHeight: 36 }}>
                                                                        <div style={{ minHeight: "12px" }} className={market.bettingType === "BOOKMAKER" ? ((!!runner_bk.lay[0] && parseFloat(runner_bk.lay[0].price) !== 0 && !!runner_bk.lay[0].size && runner_bk.lay[0].size !== '0' && is_active) ? "" : "flhightbook") : ""}>{!!runner_bk.lay[0] && parseFloat(runner_bk.lay[0].price) !== 0 && is_active ? (runner_bk.lay[0].price.indexOf('.') > -1 ? runner_bk.lay[0].price.substring(0, (runner_bk.lay[0].price.indexOf('.') + 3)) : runner_bk.lay[0].price) : " "}</div>
                                                                        {(market.bettingType !== "BOOKMAKER" || (!!runner_bk.lay[0] && parseFloat(runner_bk.lay[0].price) !== 0 && !!runner_bk.lay[0].size && runner_bk.lay[0].size !== '0' && is_active)) && <span className="ask-price-small"><Volume bettingType={market?.bettingType} key="l0" volume={!!runner_bk.lay[0] && parseFloat(runner_bk.lay[0].price) !== 0 && is_active ? runner_bk.lay[0].size / currencyConversion : ""} multiplayFector={multiplayFector} /></span>}
                                                                    </a>}
                                                                    {!!runner_bk.lay && <a id="btnBack" className="btn-lay lay-light-bg mobile-hide" side="lay" onClick={() => { !!runner_bk.lay[1] && !!runner_bk.lay[1].price && runner_bk.lay[1].price > 0 && !market.betLock && this.selectBid(runner.name, runner_bk.lay[1].price, market.marketId, "lay", runner) }} style={!!runner_bk.lay[1] && runner_bk.lay[1].has_blink ? { background: "gold", minHeight: 36 } : { minHeight: 36 }}>
                                                                        <div style={{ minHeight: "12px" }} className={market.bettingType === "BOOKMAKER" ? ((!!runner_bk.lay[1] && parseFloat(runner_bk.lay[1].price) !== 0 && !!runner_bk.lay[1].size && runner_bk.lay[1].size !== '0' && is_active) ? "" : "flhightbook") : ""}>{!!runner_bk.lay[1] && parseFloat(runner_bk.lay[1].price) !== 0 && is_active ? (runner_bk.lay[1].price.indexOf('.') > -1 ? runner_bk.lay[1].price.substring(0, (runner_bk.lay[1].price.indexOf('.') + 3)) : runner_bk.lay[1].price) : " "}</div>
                                                                        {(market.bettingType !== "BOOKMAKER" || (!!runner_bk.lay[1] && parseFloat(runner_bk.lay[1].price) !== 0 && !!runner_bk.lay[1].size && runner_bk.lay[1].size !== '0' && is_active)) && <span className="ask-price-small"><Volume bettingType={market?.bettingType} key="l1" volume={!!runner_bk.lay[1] && parseFloat(runner_bk.lay[1].price) !== 0 && is_active ? runner_bk.lay[1].size / currencyConversion : "0"} multiplayFector={multiplayFector} /></span>}
                                                                    </a>}
                                                                    {!!runner_bk.lay && <a id="btnLay" className="btn-lay lay-light-bg1 mobile-hide" side="lay" onClick={() => { !!runner_bk.lay[2] && !!runner_bk.lay[2].price && runner_bk.lay[2].price > 0 && !market.betLock && this.selectBid(runner.name, runner_bk.lay[2].price, market.marketId, "lay", runner) }} style={!!runner_bk.lay[2] && runner_bk.lay[2].has_blink ? { background: "gold", minHeight: 36 } : { minHeight: 36 }}>
                                                                        <div style={{ minHeight: "12px" }} className={market.bettingType === "BOOKMAKER" ? ((!!runner_bk.lay[2] && parseFloat(runner_bk.lay[2].price) !== 0 && !!runner_bk.lay[2].size && runner_bk.lay[2].size !== '0' && is_active) ? "" : "flhightbook") : ""}>{!!runner_bk.lay[2] && parseFloat(runner_bk.lay[2].price) !== 0 && is_active ? (runner_bk.lay[2].price.indexOf('.') > -1 ? runner_bk.lay[2].price.substring(0, (runner_bk.lay[2].price.indexOf('.') + 3)) : runner_bk.lay[2].price) : " "}</div>
                                                                        {(market.bettingType !== "BOOKMAKER" || (!!runner_bk.lay[2] && parseFloat(runner_bk.lay[2].price) !== 0 && !!runner_bk.lay[2].size && runner_bk.lay[2].size !== '0' && is_active)) && <span className="ask-price-small"><Volume bettingType={market?.bettingType} key="l2" volume={!!runner_bk.lay[2] && parseFloat(runner_bk.lay[2].price) !== 0 && is_active ? runner_bk.lay[2].size / currencyConversion : "0"} multiplayFector={multiplayFector} /></span>}
                                                                    </a>}
                                                                </div>
                                                            </div>
                                                        </td>
                                                    }
                                                </tr>
                                                }
                                            </>
                                        )
                                    }
                                    )}
                                        {!!this.props.msgMarket && this.state.mktMsg === '' &&
                                            <tr className="">
                                                <td colSpan="2"><span className="fancymassage float-right bmmassage"><i className="fa fa-envelope mr-1"></i> {this.props.msgMarket}</span></td>
                                            </tr>
                                        }
                                        {this.state.mktMsg !== '' &&
                                            <tr className="">
                                                <td colSpan="2"><span className="fancymassage float-right bmmassage"><i className="fa fa-envelope mr-1"></i> {this.state.mktMsg}</span></td>
                                            </tr>
                                        }
                                    {
                                        this.props.selected_market === market.marketId &&
                                        <BetForm amount={this.state.amount} loadingBet={this.props.loadingBet} notify={(msg, type) => { this.props.notify(msg, type) }} eventMarket={market} selcted_bet_option={this.props.selcted_bet_option} curBets={this.props.curBets} updateExpo={(expo) => { this.updateExpo(expo) }} selectionId={this.state.selectionId} runner_name={this.state.runner_name} bid_at={this.state.bid_at} betForm={this.props.betForm} addBet={(data) => { this.addBetFn(data, market) }} />
                                    }
                                </tbody>
                            </table>
                        }
                    </div>
                </div>}
            </>
        )
    }
}
